<template>
<div class="listServices page">
  <!-- Компонент listServices -->
  <div class=" d-flex align-center pb-4 mb-4">
    <h1 class="font-lg">Каталог услуг</h1>
  </div>
  <div
    class="d-flex gap-4"
  >

    <div class="pt-4 d-flex flex-column gap-3">
      <div v-for="service of validateServices" :key="service.id">
        <ServicePreview  v-if="service.status ==='published'" :preview="service"/>
      </div>
    </div>
    <div class="banner_preview pt-1">
      <BannerPreview :uploadFile="currentBanner" class="col-12" @clickBanner="showModalContact = !showModalContact"/>
    </div>

  </div>

  <ModalContactManager
    :showModalContact="showModalContact"
    @acceptSend="goToLink"
    @closeModal="showModalContact = false"
  />
</div>
</template>

<script>
import BannerPreview from '@/components/admin-panel/BannerPreview.vue';
import { mapActions, mapGetters } from 'vuex';
import ServicePreview from '@/components/list-services/ServicePreview.vue';
import ModalContactManager from '@/components/list-services/ModalContactManager.vue';

/**
 * Компонент: listServices
 * Описание:
 */
export default {
  name: 'listServices',

  components: {
    ModalContactManager,
    ServicePreview,
    BannerPreview,
  },

  props: {},

  data() {
    return {
      showModalContact: false
    };
  },

  computed: {
    ...mapGetters({
      bannerLinks: 'users/admins/hasBannerLinks',
      user: 'auth/user',
      services: 'services/services/GET_ALL_SERVICES',
    }),
    currentBanner() {
      return {
        isUpload: !!this.bannerLinks,
        image: this.bannerLinks ? this.bannerLinks : null,
      };
    },
    validateServices: {
      get() {
        return this.services.filter((service) => service.main_image_url);
      }
    }
  },

  watch: {},

  created() {
  },

  mounted() {
    this.getCurrentBanner();
    this.GET_ALL_SERVICES();
  },

  beforeDestroy() {
  },

  methods: {
    ...mapActions({
      bannerLink: 'users/admins/bannerLink',
      GET_ALL_SERVICES: 'services/services/GET_ALL_SERVICES',
    }),
    getCurrentBanner() {
      return this.bannerLink();
    },
    goToLink() {
      window.open('https://t.me/Team_Assessment', '_blank');
    },
  },
};
</script>

<style scoped lang="scss">
.listServices {
  /* Стили компонента */
  .banner_preview{
    max-width: 500px;
    width: 100%;
  }
}
</style>
